import { signInTypes } from '../../constants/signin'
import { loginFieldsRegex, signUpTabs } from '../../constants/storage'

export default function getIdentityType(tabSelected, data) {
  const params = {}
  if (tabSelected === signUpTabs.EMAIL) {
    params.field_type = data.email.match(loginFieldsRegex.EMAIL)
      ? signInTypes.EMAIL
      : signInTypes.IDENTITY_NUMBER
    params.identification = data.email
    params.password = data.password
  } else {
    params.field_type = signInTypes.PHONE_NUMBER
    params.cellphone = data.cellphone
    params.cellphone_prefix = 54
  }
  return params
}
